import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MemberAccess } from 'app/trello/models/member-access';
import { RequestErrorThrower } from 'app/trello/services/request-error-thrower';
import { TokenService } from 'app/trello/services/token.service';
import { environment } from 'environments/environment';
import { catchError, Observable, switchMap, take } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApiTokenSender {

  constructor(
    private readonly http: HttpClient,
    private readonly requestErrorThrower: RequestErrorThrower,
    private readonly tokenService: TokenService,
  ) {
  }

  public send(
    apiToken: string,
  ): Observable<MemberAccess> {

    const url = `${environment.apiRoot}${environment.endpoints.apiToken}`;

    return this.tokenService.userToken
      .pipe(
        take(1),
        switchMap((userToken) =>

          this.http.post<MemberAccess>(
            url,
            {apiToken},
            {headers: {Authorization: `Bearer ${userToken}`}},
          )
        ),
        catchError((error: any) => {

          console.error('An error occurred sending api token:', error);

          return this.requestErrorThrower.throwError(error);
        }),
      );
  }

}
